import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import CircleOption from "../../components/filterOption/CircleOption";
import FilterMenu from "../../components/filters/FilterMenu";

/**
 * Demo component for FilterMenu
 * Shows how to implement a dropdown filter with CircleOption components
 */
const FilterMenuDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({
    status: {},
    priority: {},
  });

  // Sample filter options
  const statusOptions = ["Gap", "Compliant", "Snoozed", "Excluded"];
  const priorityOptions = ["Lowest", "Low", "Medium", "High", "Highest"];

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="subtitle2">FilterMenu with CircleOption:</Typography>
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        flexWrap="wrap"
        alignItems="center"
      >
        {/* Status Filter */}
        <FilterMenu
          filterName="Status"
          fieldName="status"
          options={statusOptions.map((status) => ({
            name: status,
            label: <CircleOption label={status} type="status" />,
            displayName: status,
          }))}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          fullOptions={statusOptions}
        />

        {/* Priority Filter */}
        <FilterMenu
          filterName="Priority"
          fieldName="priority"
          options={priorityOptions.map((priority) => ({
            name: priority,
            label: <CircleOption label={priority} type="priority" />,
            displayName: priority,
          }))}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
          fullOptions={priorityOptions}
        />
      </Box>

      <Divider />

      <Typography variant="subtitle2">Selected Filters:</Typography>
      <pre
        style={{
          backgroundColor: "#f5f5f5",
          padding: "12px",
          borderRadius: "4px",
          fontSize: "0.8rem",
          overflow: "auto",
        }}
      >
        {JSON.stringify(appliedFilters, null, 2)}
      </pre>
    </Box>
  );
};

export default FilterMenuDemo;
